import React from "react";
import PropTypes from "prop-types";
import { Form } from "antd";
import cx from "classnames";
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { OrderedMap } from "immutable";
import CaseService from "services/case-service";
import "styles/form.css";
import { INPUT_TYPES } from "constants";
// const FormItem = Form.Item;

const FORM_FIELDS = new OrderedMap({
    rejection_reason_category: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Rejection Reason Category",
        rules: [
            {
                required: true,
                message: "Please Select atleast 1 reason"
            }
        ],
        options: []
    },
    rejection_reason_subcategory: {
        type: INPUT_TYPES.SELECT,
        placeholder: "Rejection Reason",
        rules: [],
        options: []
    },
    rejection_remarks: {
        type: INPUT_TYPES.TEXTAREA,
        placeholder: "Rejection Remarks",
        size: "large",
        rules: [
            {
                required: true,
                message: "Rejection remarks are required"
            }
        ],
        onChange: null
    }
});
class RejectModalContent extends React.Component {
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        rejectReasonsList: [],
        remarks: "",
        reason: "",
        subCategories: null
    };

    componentDidMount() {
        CaseService.getCategoryWiseReasons(this.props.stageId, 4 /*REJECT*/).then(({ data }) => {
            this.setState({
                rejectReasonsList: data
            }, () => this.forceUpdate());
        });
    }

    onChangeRemarks = remarks => {
        this.props.onChange({
            remarks: remarks.target.value,
            reason: this.state.reason
        });
    };

    onSelectReason = val => {
        this.setState({
            reason: this.state.reason + ", " +val
        });
    }

    onSelectReasonCategory = val => {
        let reasonCategory = this.state.rejectReasonsList && this.state.rejectReasonsList.find(_ => _.id == val);
        if(reasonCategory) {
            this.setState({
                reason: reasonCategory.name,
                subCategories: !reasonCategory.sub_categories.length ? null : reasonCategory.sub_categories
            });
        }
    }

    enhanceFormFields = () => {
        return FORM_FIELDS
            .setIn(["rejection_reason_category", "options"], this.state.rejectReasonsList.map((_) => ({
                label: _.name,
                value: _.id
            })))
            .setIn(["rejection_reason_category", "onSelect"], this.onSelectReasonCategory)
            .setIn(["rejection_reason_subcategory", "options"], this.state.subCategories && this.state.subCategories.map((_) => ({
                label: _.sub_category_name,
                value: _.sub_category_name
            })))
            .setIn(["rejection_reason_subcategory", "onSelect"], this.onSelectReason)
            .setIn(["rejection_remarks", "onChange"], this.onChangeRemarks);
    }

    render() {
        this.fields = this.enhanceFormFields();
        return (
            <React.Fragment>
                <Form hideRequiredMark={false} className={cx("form", "br-3")}>
                    <div className={"form-row"} style={{ display: "block" }}>
                        {this.fields
                            .filter((_, k) => 
                                (!this.state.rejectReasonsList || !this.state.rejectReasonsList.length) ? 
                                    k !== "rejection_reason_category" : 
                                    _ !== null
                            )
                            .filter((_, k) => !this.state.subCategories ? k !== "rejection_reason_subcategory" : _ !== null)
                            .map((field, fieldName) => {
                                return this.fieldGenerator(
                                    fieldName,
                                    field,
                                    this.getErrorOnField(fieldName)
                                )();
                            }).toList()}
                    </div>
                </Form>
            </React.Fragment>
        );
    }
}

RejectModalContent.propTypes = {
    onChange: PropTypes.func,
    form: PropTypes.object,
    rejectReason: PropTypes.object,
    stageId: PropTypes.number
};

export default Form.create({})(RejectModalContent);
